import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/PublicLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Beliefs from "@/pages/Beliefs";
import Events from "@/pages/Events";
import Sermons from "@/pages/Sermons";
import Ministries from "@/pages/Ministries";
import MinistryDetail from "@/pages/MinistryDetail";
import SundaySchool from "@/pages/SundaySchool";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Testimony from "@/pages/Testimony";
import TestimoniesArchive from "@/pages/TestimoniesArchive";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/beliefs" element={<Beliefs />} />
              <Route path="/events" element={<Events />} />
              <Route path="/sermons" element={<Sermons />} />
              <Route path="/ministries" element={<Ministries />} />
              <Route path="/ministries/:slug" element={<MinistryDetail />} />
              <Route path="/sunday-school" element={<SundaySchool />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/testimonies" element={<TestimoniesArchive />} />
              <Route path="/testimony" element={<Testimony />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster richColors theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
